'use client'

import React from 'react'
import classNames from 'classnames'
import NextLink from 'next/link'

import OpenInNewTabIcon from 'public/icons/open-in-new-window.svg'

interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  externalUrl?: string
  prefetch?: boolean
  shallow?: boolean
}

const Link: React.FC<LinkProps> = ({
  externalUrl,
  children,
  prefetch,
  shallow,
  ...props
}) => {
  if (externalUrl) {
    return (
      <a
        {...props}
        href={externalUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={classNames(props.className, 'flex items-center gap-1')}
      >
        {children}

        <span className="p-[2px]">
          <OpenInNewTabIcon />
        </span>
      </a>
    )
  }

  return (
    <NextLink
      {...props}
      href={props.href || '#'}
      prefetch={prefetch}
      shallow={shallow}
    >
      {children}
    </NextLink>
  )
}

export default Link
